<ng-container *ngIf="dataIsLoaded">
  <div class="banner">
    <div class="container bodyContent">
      <h1 class="bannerHeading">{{ data['main-heading'] }}</h1>
      <div class="bannerText">{{ data['main-paragraph'] }}</div>
      <h4 class="bannerTitle">{{ data['main-subheading'] }}</h4>
    </div>
  </div>
  <div class="container bodyContent">
    <div class="mainWrapper">
      <h2>{{ data['heading1'] }}</h2>
      <div class="cardWrapper">
        <div class="card">
          <div class="card-title card-title-1"></div>
          <div class="card-body">
            <h6 class="cardBodySubTitle">{{ data['card1-heading-subtitle'] }}</h6>
            <h4 class="cardBodyTitle">{{ data['card1-heading'] }}</h4>
            <div class="cardBodyTitleSpacer cardBodyTitleSpacer-1"></div>
            <div class="cardBodyParagraph">{{ data['card1-heading-pg'] }}</div>
            <div class="cardBodySpacer"></div>
            <div class="cardBodyListWrapper" [innerHTML]="data['card1-list']"></div>
            <div class="cardBodyBottomWrapper">
              <div class="cardBodyBottom">
                <a [href]="preferredLink" target="_blank" class="btn btn-teal">{{ data['card1-btn'] }}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-title card-title-2"></div>
          <div class="card-body">
            <h6 class="cardBodySubTitle">{{ data['card2-heading-subtitle'] }}</h6>
            <h4 class="cardBodyTitle">{{ data['card2-heading'] }}</h4>
            <div class="cardBodyTitleSpacer cardBodyTitleSpacer-2"></div>
            <div class="cardBodyParagraph">{{ data['card2-heading-pg'] }}</div>
            <div class="cardBodySpacer"></div>
            <div class="cardBodyListWrapper" [innerHTML]="data['card2-list']"></div>
            <div class="cardBodyBottomWrapper">
              <div class="cardBodyBottom">
                <a [href]="affiliateLink" target="_blank" class="btn btn-purple">{{ data['card2-btn'] }}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-title card-title-3"></div>
          <div class="card-body">
            <h6 class="cardBodySubTitle">{{ data['card3-heading-subtitle'] }}</h6>
            <h4 class="cardBodyTitle">{{ data['card3-heading'] }}</h4>
            <div class="cardBodyTitleSpacer cardBodyTitleSpacer-3"></div>
            <div class="cardBodyParagraph">{{ data['card3-heading-pg'] }}</div>
            <div class="cardBodySpacer"></div>
            <div class="cardBodyListWrapper" [innerHTML]="data['card3-list']"></div>
            <div class="cardBodyBottomWrapper">
              <ng-container *ngIf="isPwp; else notPwpCard">
                <div class="cardBodyBottom">
                  <a [href]="associateLink | async" target="_blank" class="btn btn-blue">{{ data['card3-btn'] }}</a>
                </div>
              </ng-container>
              <ng-template #notPwpCard>
                <div class="cardBodyBottomText" [innerHTML]="data['card3-text']"></div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="dividerWrapper">&nbsp;</div>
      <div class="tableMainWrapper">
        <div class="imgWrapper"><img src="{{ data['how-to-earn-img'] }}" alt="{{ data['earn-heading'] }}" /></div>
        <h1 class="tableMainHeader">{{ data['earn-heading'] }}</h1>
        <div class="tableMainParagraph">{{ data['earn-pg'] }}</div>
        <div class="tableGridWrapper">
          <div class="table">
            <div class="tableContainer">
              <div class="colLabel border-start-0">&nbsp;</div>
              <div class="colPreferred border-start-0">
                <div class="colCap"></div>
                <h6 class="">{{ data['card1-heading'] }}</h6>
              </div>
              <div class="colAffiliate">
                <div class="colCap"></div>
                <h6 class="">{{ data['card2-heading'] }}</h6>
              </div>
              <div class="colAssociate border-end-0">
                <div class="colCap"></div>
                <h6 class="">{{ data['card3-heading'] }}</h6>
              </div>
            </div>
            <div class="tableContainer">
              <div class="colLabel">
                <h6 class="colTitle">{{ data['earn-table-body1'] }}</h6>
              </div>
              <div class="colPreferred"></div>
              <div class="colAffiliate"></div>
              <div class="colAssociate"></div>
            </div>

            <div class="tableContainer">
              <div class="colLabel">
                <div class="colText">{{ data['earn-table-body2'] }}</div>
              </div>
              <div class="colPreferred">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>

              <div class="colAffiliate">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
              <div class="colAssociate">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
            </div>

            <div class="tableContainer">
              <div class="colLabel">
                <div class="colText">{{ data['earn-table-body3'] }}</div>
              </div>
              <div class="colPreferred">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
              <div class="colAffiliate">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
              <div class="colAssociate">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
            </div>

            <div class="tableContainer">
              <div class="colLabel">
                <div class="colText">{{ data['earn-table-body4'] }}</div>
              </div>
              <div class="colPreferred">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
              <div class="colAffiliate">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
              <div class="colAssociate"></div>
            </div>

            <div class="tableContainer">
              <div class="colLabel">
                <div class="colText">{{ data['earn-table-body5'] }}</div>
              </div>
              <div class="colPreferred"></div>
              <div class="colAffiliate">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
              <div class="colAssociate"></div>
            </div>

            <div class="tableContainer">
              <div class="colLabel">
                <div class="colText">{{ data['earn-table-body6'] }}</div>
              </div>
              <div class="colPreferred"></div>
              <div class="colAffiliate"></div>
              <div class="colAssociate">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
            </div>

            <div class="tableContainer">
              <div class="colLabel">
                <div class="colText">{{ data['earn-table-body7'] }}</div>
              </div>
              <div class="colPreferred"></div>
              <div class="colAffiliate"></div>
              <div class="colAssociate">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
            </div>

            <div class="tableContainer">
              <div class="colLabel">
                <div class="colText">{{ data['earn-table-body8'] }}</div>
              </div>
              <div class="colPreferred"></div>
              <div class="colAffiliate"></div>
              <div class="colAssociate">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
            </div>

            <div class="tableContainer">
              <div class="colLabel">
                <div class="colText">{{ data['earn-table-body9'] }}</div>
              </div>
              <div class="colPreferred"></div>
              <div class="colAffiliate"></div>
              <div class="colAssociate">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
            </div>

            <div class="tableContainer">
              <div class="colLabel">
                <h6 class="colTitle">{{ data['earn-table-body10'] }}</h6>
              </div>
              <div class="colPreferred"></div>
              <div class="colAffiliate"></div>
              <div class="colAssociate"></div>
            </div>

            <div class="tableContainer">
              <div class="colLabel">
                <div class="colText">{{ data['earn-table-body11'] }}</div>
              </div>
              <div class="colPreferred">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
              <div class="colAffiliate">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
              <div class="colAssociate">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
            </div>

            <div class="tableContainer">
              <div class="colLabel">
                <div class="colText">{{ data['earn-table-body12'] }}</div>
              </div>
              <div class="colPreferred"></div>
              <div class="colAffiliate">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
              <div class="colAssociate">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
            </div>

            <div class="tableContainer">
              <div class="colLabel">
                <div class="colText">{{ data['earn-table-body13'] }}</div>
              </div>
              <div class="colPreferred"></div>
              <div class="colAffiliate"></div>
              <div class="colAssociate">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
            </div>

            <div class="tableContainer">
              <div class="colLabel">
                <h6 class="colTitle">{{ data['earn-table-body14'] }}</h6>
              </div>
              <div class="colPreferred"></div>
              <div class="colAffiliate"></div>
              <div class="colAssociate"></div>
            </div>

            <div class="tableContainer">
              <div class="colLabel">
                <div class="colText">{{ data['earn-table-body15'] }}</div>
              </div>
              <div class="colPreferred">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
              <div class="colAffiliate"></div>
              <div class="colAssociate"></div>
            </div>

            <div class="tableContainer">
              <div class="colLabel">
                <div class="colText">{{ data['earn-table-body16'] }}</div>
              </div>
              <div class="colPreferred"></div>
              <div class="colAffiliate">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
              <div class="colAssociate"></div>
            </div>

            <div class="tableContainer">
              <div class="colLabel">
                <div class="colText">{{ data['earn-table-body17'] }}</div>
              </div>
              <div class="colPreferred"></div>
              <div class="colAffiliate"></div>
              <div class="colAssociate">
                <div class="checkMarkWrapper">
                  <div class="checkMark"></div>
                </div>
              </div>
            </div>
            <div class="tableContainer">
              <div class="colLabel border-start-0 border-bottom-0">&nbsp;</div>

              <div class="colPreferred">
                <a [href]="preferredLink" target="_blank" class="btn btn-teal colFooterText">{{ data['card1-btn'] }}</a>
              </div>

              <div class="colAffiliate">
                <a [href]="affiliateLink" target="_blank" class="btn btn-purple colFooterText">{{
                  data['card2-btn']
                }}</a>
              </div>

              <div class="colAssociate">
                <ng-container *ngIf="isPwp; else notPwp">
                  <a [href]="associateLink | async" target="_blank" class="btn btn-blue colFooterText">{{
                    data['card3-btn']
                  }}</a>
                </ng-container>
                <ng-template #notPwp>
                  <div class="colFooterText" [innerHTML]="data['card3-text']"></div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="bannerBottomWrapper">
    <div class="bannerBottomText">
      <h2>{{ data['footer-heading'] }}</h2>
    </div>
  </div>
  <div class="container">
    <div class="footerNote" [innerHTML]="data['footer-note']"></div>
  </div>
</ng-container>
